"use strict";

exports.__esModule = true;
exports.Row = exports.PartsWrapper = exports.PartCountSelector = exports.Part = exports.NumberInputGroup = exports.FormWrapper = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Core = require("../../../Core");
var _icons = require("@blueprintjs/icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var PartsWrapper = exports.PartsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PartCountSelector__PartsWrapper",
  componentId: "sc-1h6pjf5-0"
})(["display:flex;flex-direction:column;flex:1;justify-content:center;"]);
var FormWrapper = exports.FormWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PartCountSelector__FormWrapper",
  componentId: "sc-1h6pjf5-1"
})(["display:flex;flex-direction:column;flex:2;"]);
var NumberInputGroup = exports.NumberInputGroup = (0, _styledComponents["default"])(_core.InputGroup).withConfig({
  displayName: "PartCountSelector__NumberInputGroup",
  componentId: "sc-1h6pjf5-2"
})([".", "{width:100px;text-align:center;}"], _core.Classes.INPUT);
var Row = exports.Row = _styledComponents["default"].div.withConfig({
  displayName: "PartCountSelector__Row",
  componentId: "sc-1h6pjf5-3"
})(["display:flex;padding:0.8rem 0;border-top 1px solid rgba(0,0,0,0.1);align-items:center;"]);
var Part = exports.Part = _styledComponents["default"].p.withConfig({
  displayName: "PartCountSelector__Part",
  componentId: "sc-1h6pjf5-4"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:500px;"]);
var PartCountSelector = exports.PartCountSelector = function PartCountSelector(props) {
  var translator = (0, _react.useContext)(_Core.TranslatorContext);
  var translate = translator.translate;
  var goodPartCount = props.goodPartCount,
    badPartCount = props.badPartCount,
    setGoodPartCount = props.setGoodPartCount,
    setBadPartCount = props.setBadPartCount;
  var setGoodPartCountValue = function setGoodPartCountValue(e) {
    if (e.target.value >= 0) {
      setGoodPartCount(e.target.value);
    }
  };
  var increaseGoodPartCountValue = function increaseGoodPartCountValue() {
    setGoodPartCount(goodPartCount + 1);
  };
  var decreaseGoodPartCountValue = function decreaseGoodPartCountValue() {
    if (goodPartCount > 0) {
      setGoodPartCount(goodPartCount - 1);
    }
  };
  var setBadPartCountValue = function setBadPartCountValue(e) {
    if (e.target.value >= 0) {
      setBadPartCount(e.target.value);
    }
  };
  var increaseBadPartCountValue = function increaseBadPartCountValue() {
    setBadPartCount(badPartCount + 1);
  };
  var decreaseBadPartCountValue = function decreaseBadPartCountValue() {
    if (badPartCount > 0) {
      setBadPartCount(badPartCount - 1);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(PartsWrapper, null, /*#__PURE__*/_react["default"].createElement(Part, null, translate("PartCountSelector.value.label", "Good Parts: " + goodPartCount))), /*#__PURE__*/_react["default"].createElement(FormWrapper, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_core.ControlGroup, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    large: true,
    onClick: decreaseGoodPartCountValue,
    "data-testid": "PartCountSelector.decreaseGoodPartCount.button",
    icon: _icons.IconNames.MINUS
  }), /*#__PURE__*/_react["default"].createElement(NumberInputGroup, {
    large: true,
    onChange: setGoodPartCountValue,
    value: goodPartCount,
    "data-testid": "PartCountSelector.goodPartCount.input"
  }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    large: true,
    onClick: increaseGoodPartCountValue,
    "data-testid": "PartCountSelector.increaseGoodPartCount.button",
    icon: _icons.IconNames.PLUS
  }))))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(PartsWrapper, null, /*#__PURE__*/_react["default"].createElement(Part, null, translate("PartCountSelector.value.label", "Bad Parts: " + badPartCount))), /*#__PURE__*/_react["default"].createElement(FormWrapper, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_core.ControlGroup, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    large: true,
    onClick: decreaseBadPartCountValue,
    "data-testid": "PartCountSelector.decreaseBadPartCount.button",
    icon: _icons.IconNames.MINUS
  }), /*#__PURE__*/_react["default"].createElement(NumberInputGroup, {
    large: true,
    onChange: setBadPartCountValue,
    "data-testid": "PartCountSelector.badPartCount.input",
    value: badPartCount
  }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    large: true,
    onClick: increaseBadPartCountValue,
    "data-testid": "PartCountSelector.increaseBadPartCount.button",
    icon: _icons.IconNames.PLUS
  }))))));
};